import { createContext, useContext } from 'react';

import type { FiltersType } from '@/data-sources/contract';

export type PageMeta = {
  routeId: string;
  /** The filters bar this page draws; null when it draws none (and so filters by nothing). */
  filtersType: FiltersType | null;
};

export const PageContext = createContext<PageMeta>({ routeId: '', filtersType: null });

export const usePageMeta = () => useContext(PageContext);
